// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FVDM","col":"styles_col__1i8ED"};